/* ═══════════════════════════════════════
   GLOBAL.JS — PALS mafer
   Nav · Scroll Reveal · Mobile menu · Filtros · Cart Drawer · Shipping Bar
   ═══════════════════════════════════════ */

/* ── Money helper (fuente única de formato) ──
   Replica el render de Liquid `| money`: símbolo + separador de miles +
   2 decimales + ' MXN'. Recibe centavos. Se expone en window.Theme.money
   para que cart-page.js consuma el MISMO formato y el estado post-AJAX
   coincida con el HTML pintado por Liquid. */
window.Theme = window.Theme || {};
/* Nombre visible por handle: lee el mapa que theme.liquid vuelca en
   #pals-display-names (settings.product_display_names). Sin entrada → fallback. */
window.Theme.displayName = function (handle, fallback) {
  if (!window.Theme.displayNames) {
    var map = {};
    var el = document.getElementById('pals-display-names');
    if (el) { try { map = JSON.parse(el.textContent) || {}; } catch (err) { map = {}; } }
    window.Theme.displayNames = map;
  }
  var key = String(handle || '').toLowerCase();
  return (key && window.Theme.displayNames[key]) || fallback || '';
};
window.Theme.money = function (cents) {
  return '$' + (Number(cents) / 100).toLocaleString('es-MX', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + ' MXN';
};

/* ── Helpers globales de carrito (hallazgos 6/7/9) ──
   Fuente única: cart-page.js consume estos mismos helpers. */

/* h7: escape ÚNICO para todo string de datos interpolado a innerHTML. */
window.Theme.escapeHtml = function (str) {
  return String(str == null ? '' : str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
};

/* h7: resize vía Shopify CDN (patrón ?/&width=N) — nunca la imagen original. */
window.Theme.resizeImage = function (url, width) {
  if (!url) return url;
  return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
};

/* h9: UN evento custom para TODAS las mutaciones del carrito (add/change/remove,
   drawer o página). detail = cart JSON completo. Los listeners pintan. */
window.Theme.emitCartUpdated = function (cart) {
  document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
};

/* h9: refetch del estado + emit (para /cart/add.js, que devuelve el item, no el cart). */
window.Theme.refreshCart = function () {
  return fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { window.Theme.emitCartUpdated(cart); return cart; })
    .catch(function () {});
};

/* h6: cola que SERIALIZA los POST a /cart/change.js — nunca en paralelo,
   nunca fuera de orden. Emite cart:updated con cada respuesta. */
var cartChangeQueue = Promise.resolve();
window.Theme.cartChange = function (key, qty) {
  var run = cartChangeQueue.then(function () {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/change ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        window.Theme.emitCartUpdated(cart);
        return cart;
      });
  });
  /* La cola sobrevive errores; el caller recibe el rechazo sin catch. */
  cartChangeQueue = run.catch(function () {});
  return run;
};

document.addEventListener('DOMContentLoaded', function () {

  var money = window.Theme.money;

  /* ── Scroll Reveal ── */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -80px 0px' });

    revealEls.forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    revealEls.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* ── Mobile menu ── */
  var burger = document.getElementById('nav-burger');
  var mobileMenu = document.getElementById('nav-mobile-menu');
  var mobileClose = document.getElementById('nav-mobile-close');

  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      mobileMenu.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      mobileMenu.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      trapFocus(mobileMenu, closeMobileMenu);
    });

    if (mobileClose) {
      mobileClose.addEventListener('click', closeMobileMenu);
    }

    mobileMenu.addEventListener('click', function (e) {
      if (e.target === mobileMenu) closeMobileMenu();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
        closeMobileMenu();
      }
    });

    function closeMobileMenu() {
      releaseFocus(mobileMenu);
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      burger.focus();
    }
  }

  /* ── Product grid filter (2 grupos: categoría + formato, bidireccional) ── */
  var SYNONYMS = { 'bits': 'bolsa', 'bolsa': 'bits' };
  var VALID_FORMATS_BY_CAT = {
    'energia':  ['individual', 'caja-6', 'caja-18'],
    'proteina': ['individual', 'caja-6', 'caja-18'],
    'bits':     ['bolsa']
  };
  var VALID_CATS_BY_FORMAT = {
    'individual': ['energia', 'proteina'],
    'caja-6':     ['energia', 'proteina'],
    'caja-18':    ['energia', 'proteina'],
    'bolsa':      ['bits']
  };

  var filterState = { category: 'all', format: 'all' };
  var productCards = document.querySelectorAll('#products-grid .product-card');

  function syncFilterButtons() {
    document.querySelectorAll('[data-filter-type="category"]').forEach(function (b) {
      var active = b.getAttribute('data-filter') === filterState.category;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    document.querySelectorAll('[data-filter-type="format"]').forEach(function (b) {
      var active = b.getAttribute('data-filter') === filterState.format;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  document.querySelectorAll('.filter-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var type = btn.getAttribute('data-filter-type');
      var val = btn.getAttribute('data-filter');
      if (!type) return;

      if (type === 'category') {
        if (filterState.category === val && val !== 'all') {
          filterState.category = 'all';
          if (SYNONYMS[val]) filterState.format = 'all';
        } else {
          filterState.category = val;
          if (SYNONYMS[val]) {
            filterState.format = SYNONYMS[val];
          } else if (val !== 'all' && filterState.format !== 'all') {
            var validFmts = VALID_FORMATS_BY_CAT[val] || [];
            if (validFmts.indexOf(filterState.format) === -1) filterState.format = 'all';
          }
        }
      } else if (type === 'format') {
        if (filterState.format === val && val !== 'all') {
          filterState.format = 'all';
          if (SYNONYMS[val]) filterState.category = 'all';
        } else {
          filterState.format = val;
          if (SYNONYMS[val]) {
            filterState.category = SYNONYMS[val];
          } else if (val !== 'all' && filterState.category !== 'all') {
            var validCats = VALID_CATS_BY_FORMAT[val] || [];
            if (validCats.indexOf(filterState.category) === -1) filterState.category = 'all';
          }
        }
      }

      syncFilterButtons();
      applyFilters();
    });
  });

  function applyFilters() {
    productCards.forEach(function (card) {
      var cats = (card.getAttribute('data-categories') || '').split(' ');
      var fmts = (card.getAttribute('data-formats') || '').split(' ');
      var line = card.getAttribute('data-line') || '';

      var catMatch = filterState.category === 'all'
        || cats.indexOf(filterState.category) !== -1
        || line === filterState.category;

      var fmtMatch = filterState.format === 'all'
        || fmts.indexOf(filterState.format) !== -1;

      card.style.display = (catMatch && fmtMatch) ? '' : 'none';
    });
  }

  /* ── PDP: Qty buttons ── */
  var qtyMinus = document.getElementById('qty-minus');
  var qtyPlus = document.getElementById('qty-plus');
  var qtyVal = document.getElementById('qty-val');
  var qtyInput = document.getElementById('product-quantity');

  if (qtyMinus && qtyPlus && qtyVal) {
    var qty = 1;

    qtyMinus.addEventListener('click', function () {
      if (qty > 1) {
        qty--;
        qtyVal.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
      }
    });

    qtyPlus.addEventListener('click', function () {
      qty++;
      qtyVal.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
    });
  }

  /* ── PDP: Thumbnail switcher ── */
  var thumbs = document.querySelectorAll('.pdp__thumb');
  var mainImage = document.getElementById('pdp-main-image');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-img-src');
      var alt = thumb.getAttribute('data-img-alt');
      if (mainImage && src) {
        /* Limpiar srcset/sizes antes de asignar src para que el browser
           no ignore el cambio priorizando el descriptor de srcset viejo. */
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = src;
        if (alt) mainImage.alt = alt;
      }
      thumbs.forEach(function (t) {
        t.classList.remove('active');
        t.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('active');
      thumb.setAttribute('aria-pressed', 'true');
    });
  });

  /* ── Cart Drawer ── */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
  var cartDrawerClose = document.getElementById('cart-drawer-close');
  var navCartLink = document.getElementById('nav-cart-link');
  var lastFocusedBeforeDrawer = null;

  /* a11y F4: focus trap helpers — h8: callback de cierre POR INSTANCIA (nada de
     closeCartDrawer hardcodeado) y focusables recalculados en CADA Tab, porque
     el contenido del drawer es dinámico (carrito vaciado ya no deja escapar Tab). */
  function getFocusable(element) {
    var focusableSelectors = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.from(element.querySelectorAll(focusableSelectors));
  }

  function trapFocus(element, onClose) {
    function handleKeydown(e) {
      if (e.key === 'Tab') {
        var focusable = getFocusable(element);
        if (!focusable.length) { e.preventDefault(); return; }
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        } else if (focusable.indexOf(document.activeElement) === -1) {
          /* El foco quedó en un nodo re-renderizado/removido: re-ancla. */
          e.preventDefault();
          first.focus();
        }
      }
      if (e.key === 'Escape' && typeof onClose === 'function') {
        onClose();
      }
    }

    element._trapHandler = handleKeydown;
    element.addEventListener('keydown', handleKeydown);
    var initial = getFocusable(element);
    if (initial.length) initial[0].focus();
  }

  function releaseFocus(element) {
    if (element._trapHandler) {
      element.removeEventListener('keydown', element._trapHandler);
      delete element._trapHandler;
    }
  }

  function openCartDrawer(skipRefresh) {
    if (!cartDrawer) return;
    /* h9: abrir siempre refresca el estado (salvo que el caller ya lo hizo). */
    if (!skipRefresh) window.Theme.refreshCart();
    lastFocusedBeforeDrawer = document.activeElement;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    trapFocus(cartDrawer, closeCartDrawer);
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    releaseFocus(cartDrawer);
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocusedBeforeDrawer) {
      lastFocusedBeforeDrawer.focus();
      lastFocusedBeforeDrawer = null;
    }
  }

  if (navCartLink) {
    navCartLink.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  }

  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener('click', closeCartDrawer);
  }

  if (cartDrawerClose) {
    cartDrawerClose.addEventListener('click', closeCartDrawer);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.getAttribute('aria-hidden') === 'false') {
      closeCartDrawer();
    }
  });

  /* ── Shipping bar UI update — handles both cart-drawer bar and announcement bar ── */
  function refreshShippingUI(cart) {
    var shippingBar = document.getElementById('cart-shipping-bar');
    var announcementBar = document.getElementById('announcement-bar');

    [shippingBar, announcementBar].forEach(function (el) {
      if (!el) return;

      var thresholdMXN = parseInt(el.getAttribute('data-threshold') || '0', 10);
      var thresholdCents = thresholdMXN * 100;
      var textEl = el.querySelector('#cart-shipping-bar-text, #announcement-bar-text');
      var fillEl = el.querySelector('#cart-shipping-bar-fill, #announcement-bar-fill');
      var textProgress = el.getAttribute('data-text-progress') || '';
      var textUnlocked = el.getAttribute('data-text-unlocked') || '';

      if (!thresholdCents) return;

      var progressEl = fillEl ? fillEl.parentElement : null;

      if (cart.item_count === 0) {
        var textEmpty = el.getAttribute('data-text-empty') || '';
        if (textEl) {
          textEl.textContent = textEmpty;
          textEl.classList.remove('cart-shipping-bar__text--success');
        }
        if (fillEl) { fillEl.style.width = '0%'; }
        if (progressEl) { progressEl.classList.remove('has-progress'); }
      } else if (cart.total_price >= thresholdCents) {
        if (textEl) {
          textEl.textContent = '✓ ' + textUnlocked;
          textEl.classList.add('cart-shipping-bar__text--success');
        }
        if (fillEl) { fillEl.style.width = '100%'; }
        if (progressEl) { progressEl.classList.add('has-progress'); }
      } else {
        var remainingCents = thresholdCents - cart.total_price;
        var remainingFormatted = money(remainingCents);
        var pct = Math.min(100, Math.round((cart.total_price / thresholdCents) * 100));
        if (textEl) {
          textEl.textContent = textProgress.replace('{amount}', remainingFormatted);
          textEl.classList.remove('cart-shipping-bar__text--success');
        }
        if (fillEl) { fillEl.style.width = pct + '%'; }
        if (progressEl) { progressEl.classList.add('has-progress'); }
      }
    });
  }

  /* ── Render cart data into the drawer (shared between refreshCartDrawer + updateDrawerItem) ── */
  function applyCartData(cart) {
    var countEl = document.getElementById('cart-count');
    var drawerCount = document.getElementById('drawer-item-count');
    var drawerSubtotal = document.getElementById('drawer-subtotal');
    var drawerFoot = document.getElementById('cart-drawer-foot');

    if (countEl) countEl.textContent = cart.item_count;
    if (drawerCount) drawerCount.textContent = cart.item_count;

    if (drawerSubtotal) drawerSubtotal.textContent = money(cart.total_price);

    var itemsEl = document.getElementById('cart-drawer-items');
    var bodyEl = document.getElementById('cart-drawer-body');

    if (cart.item_count === 0) {
      /* Empty-state homologado: clona el <template id="cart-empty-tpl"> (mismo
         snippet cart-empty.liquid que el server), sin duplicar markup ni copy. */
      if (bodyEl) {
        bodyEl.innerHTML = '';
        var emptyTpl = document.getElementById('cart-empty-tpl');
        if (emptyTpl && 'content' in emptyTpl) {
          bodyEl.appendChild(emptyTpl.content.cloneNode(true));
        }
      }
      if (drawerFoot) drawerFoot.style.display = 'none';
    } else {
      if (drawerFoot) drawerFoot.style.display = '';
      if (!itemsEl) {
        var ul = document.createElement('ul');
        ul.className = 'cart-drawer__items';
        ul.id = 'cart-drawer-items';
        if (bodyEl) { bodyEl.innerHTML = ''; bodyEl.appendChild(ul); }
        itemsEl = ul;
      }
      if (itemsEl) {
        /* h7: TODO string de datos pasa por escapeHtml; imagen SIEMPRE con width=160. */
        var esc = window.Theme.escapeHtml;
        itemsEl.innerHTML = cart.items.map(function (item) {
          var imgHtml = item.featured_image && item.featured_image.url
            ? '<img class="cart-drawer__item-img" src="' + esc(window.Theme.resizeImage(item.featured_image.url, 160)) + '" alt="' + esc(item.title || 'Producto') + '" loading="lazy">'
            : '<div class="cart-drawer__item-img product-img-placeholder" aria-hidden="true">' + (item.product_title ? esc(item.product_title.charAt(0).toUpperCase()) : 'P') + '</div>';
          var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="variant">' + esc(item.variant_title) + '</p>' : '';
          var price = money(item.final_line_price);
          return '<li class="cart-drawer__item">'
            + imgHtml
            + '<div class="cart-drawer__item-info">'
            + '<h3>' + esc(window.Theme.displayName(item.handle, item.product_title)) + '</h3>'
            + variantHtml
            + '<div class="cart-drawer__item-controls">'
            + '<div class="cart-drawer__qty" data-key="' + esc(item.key) + '" data-qty="' + item.quantity + '">'
            + '<button class="drawer-qty-minus" aria-label="Restar">−</button>'
            + '<span class="cart-drawer__qty-val">' + item.quantity + '</span>'
            + '<button class="drawer-qty-plus" aria-label="Sumar">+</button>'
            + '</div>'
            + (function () {
                /* P8: respeta settings.cart_remove_icon inyectado en window.theme (theme.liquid). */
                var t = window.theme || {};
                var useIcon = t.cartRemoveIcon;
                var label = t.cartRemoveLabel || 'Eliminar';
                var inner = useIcon ? (t.cartRemoveIconSvg || '') : esc(label);
                var cls = 'cart-drawer__item-remove' + (useIcon ? ' cart-drawer__item-remove--icon' : '');
                var dname = window.Theme.displayName(item.handle, item.product_title);
                var aria = label + (dname ? ' ' + dname : '');
                return '<button class="' + cls + '" data-key="' + esc(item.key) + '" aria-label="' + esc(aria) + '">' + inner + '</button>';
              })()
            + '</div></div>'
            + '<div class="cart-drawer__item-price">' + price + '</div>'
            + '</li>';
        }).join('');
        bindDrawerItemEvents();
      }
    }

    refreshShippingUI(cart);

    /* h8: el re-render invalida el nodo enfocado → si el drawer está abierto y
       el foco cayó fuera, re-ancla dentro para que el trap siga funcionando. */
    if (cartDrawer && cartDrawer.getAttribute('aria-hidden') === 'false'
        && !cartDrawer.contains(document.activeElement)) {
      var reFocus = document.getElementById('cart-drawer-close') || getFocusable(cartDrawer)[0];
      if (reFocus) reFocus.focus();
    }
  }

  /* h9: UN listener — badge + drawer + shipping se repintan con CUALQUIER
     mutación (add/change/remove, venga del drawer o de la página /cart). */
  document.addEventListener('cart:updated', function (e) {
    if (e.detail) applyCartData(e.detail);
  });

  /* h6: estado optimista EN MEMORIA — la verdad mientras hay POSTs en vuelo.
     El DOM (data-qty) solo se lee cuando no hay nada pendiente, así picar
     +++ rápido siempre termina en la cantidad correcta. */
  var optimisticQty = {};
  var pendingCartChanges = 0;

  function readItemQty(qtyEl, key) {
    if (Object.prototype.hasOwnProperty.call(optimisticQty, key)) return optimisticQty[key];
    return parseInt(qtyEl ? qtyEl.getAttribute('data-qty') : '0', 10) || 0;
  }

  function queueDrawerChange(key, qty, qtyEl) {
    optimisticQty[key] = qty;
    if (qtyEl) {
      /* Feedback inmediato; el cart:updated final confirma. */
      qtyEl.setAttribute('data-qty', qty);
      var span = qtyEl.querySelector('.cart-drawer__qty-val');
      if (span) span.textContent = qty;
    }
    pendingCartChanges++;
    window.Theme.cartChange(key, qty)
      .catch(function () {})
      .then(function () {
        pendingCartChanges--;
        if (pendingCartChanges === 0) optimisticQty = {};
      });
  }

  function bindDrawerItemEvents() {
    var drawerBody = document.getElementById('cart-drawer-body');
    if (!drawerBody) return;

    drawerBody.querySelectorAll('.drawer-qty-minus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var qtyEl = btn.closest('.cart-drawer__qty');
        var key = qtyEl.getAttribute('data-key');
        queueDrawerChange(key, Math.max(0, readItemQty(qtyEl, key) - 1), qtyEl);
      });
    });

    drawerBody.querySelectorAll('.drawer-qty-plus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var qtyEl = btn.closest('.cart-drawer__qty');
        var key = qtyEl.getAttribute('data-key');
        queueDrawerChange(key, readItemQty(qtyEl, key) + 1, qtyEl);
      });
    });

    drawerBody.querySelectorAll('.cart-drawer__item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        queueDrawerChange(key, 0, null);
      });
    });
  }

  bindDrawerItemEvents();

  /* ── Cart AJAX add ── */
  var productForm = document.getElementById('product-form');
  var addBtn = document.getElementById('add-to-cart');
  var addBtnText = document.getElementById('add-to-cart-text');

  if (productForm && addBtn) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      /* Captura el HTML actual del botón (incluye sufijo de precio y atc_text custom,
         ya sincronizados por section-pdp.js si el usuario cambió de variante). */
      var atcOriginalHTML = addBtnText ? addBtnText.innerHTML : '';

      var formData = new FormData(productForm);
      addBtn.disabled = true;
      if (addBtnText) addBtnText.textContent = 'Agregando...';

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            if (addBtnText) addBtnText.textContent = 'Error — intenta de nuevo';
            addBtn.disabled = false;
          } else {
            if (addBtnText) addBtnText.textContent = 'Agregado.';
            window.Theme.refreshCart(); /* h9: emite cart:updated */
            openCartDrawer(true);
            setTimeout(function () {
              if (addBtnText) addBtnText.innerHTML = atcOriginalHTML;
              addBtn.disabled = false;
            }, 1800);
          }
        })
        .catch(function () {
          if (addBtnText) addBtnText.textContent = 'Error — intenta de nuevo';
          addBtn.disabled = false;
        });
    });
  }

  /* ── Quick Add to Cart ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-card__quick-add');
    if (!btn || btn.disabled) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = btn.textContent.trim();
    btn.classList.add('is-loading');
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          btn.textContent = 'Error';
          setTimeout(function () { btn.textContent = originalText; btn.classList.remove('is-loading'); }, 1500);
        } else {
          btn.textContent = '✓';
          window.Theme.refreshCart(); /* h9: emite cart:updated */
          openCartDrawer(true);
          setTimeout(function () { btn.textContent = originalText; btn.classList.remove('is-loading'); }, 1800);
        }
      })
      .catch(function () {
        btn.textContent = originalText;
        btn.classList.remove('is-loading');
      });
  });

});

/* ── Search panel toggle ── */
(function () {
  var searchBtn   = document.getElementById('nav-search-btn');
  var searchPanel = document.getElementById('nav-search-panel');
  var searchInput = document.getElementById('nav-search-input');
  var searchClose = document.getElementById('nav-search-close');
  var searchResults = document.getElementById('nav-search-results');
  if (!searchBtn || !searchPanel) return;

  function openSearch() {
    searchPanel.setAttribute('aria-hidden', 'false');
    searchBtn.setAttribute('aria-expanded', 'true');
    searchPanel.classList.add('is-open');
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 80);
  }
  function closeSearch() {
    searchPanel.setAttribute('aria-hidden', 'true');
    searchBtn.setAttribute('aria-expanded', 'false');
    searchPanel.classList.remove('is-open');
    if (searchResults) searchResults.innerHTML = '';
    if (searchInput) searchInput.value = '';
  }

  searchBtn.addEventListener('click', function () {
    if (searchPanel.classList.contains('is-open')) { closeSearch(); } else { openSearch(); }
  });
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchPanel.classList.contains('is-open')) closeSearch();
  });

  if (searchInput && searchResults) {
    var searchTimer;
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var esc = window.Theme.escapeHtml; /* h7: mismo helper único */
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<p class="nav__search-empty">Sin resultados para "' + esc(q) + '"</p>';
              return;
            }
            searchResults.innerHTML = '<ul class="nav__search-list" role="listbox">' +
              products.map(function (p) {
                return '<li class="nav__search-item" role="option"><a href="' + esc(p.url) + '" class="nav__search-link">' +
                  (p.featured_image ? '<img src="' + esc(p.featured_image.url || p.featured_image) + '" alt="" width="48" height="48" class="nav__search-thumb">' : '') +
                  '<span class="nav__search-text"><span class="nav__search-name">' + esc(p.title) + '</span>' +
                  /* /search/suggest.json da el precio en PESOS (string "35.00"), no en centavos:
   dividir entre 100 mostraba "$0.35". parseFloat directo. */
'<span class="nav__search-price">' + (p.price ? parseFloat(p.price).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }) : '') + '</span></span>' +
                  '</a></li>';
              }).join('') +
              '</ul><a href="/search?q=' + encodeURIComponent(q) + '" class="nav__search-all">Ver todos los resultados →</a>';
          })
          .catch(function () {});
      }, 280);
    });
  }
})();

/* ── Cart discount code hint toggle ── */
document.addEventListener('click', (e) => {
  if (e.target.matches('.cart__discount-toggle')) {
    const btn = e.target;
    const panel = btn.nextElementSibling;
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', !expanded);
    panel.hidden = expanded;
  }
});
